module.exports = require('./$.global');


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/$.path.js
 ** module id = 236
 ** module chunks = 0
 **/